export default [
  {
    label: "January",
    short: "Jan",
    value: 1,
    days: 31,
  },
  {
    label: "February",
    short: "Feb",
    value: 2,
    days: 29,
  },
  {
    label: "March",
    short: "Mar",
    value: 3,
    days: 31,
  },
  {
    label: "April",
    short: "Apr",
    value: 4,
    days: 30,
  },
  {
    label: "May",
    short: "May",
    value: 5,
    days: 31,
  },
  {
    label: "June",
    short: "Jun",
    value: 6,
    days: 30,
  },
  {
    label: "July",
    short: "Jul",
    value: 7,
    days: 31,
  },
  {
    label: "August",
    short: "Aug",
    value: 8,
    days: 31,
  },
  {
    label: "September",
    short: "Sep",
    value: 9,
    days: 30,
  },
  {
    label: "October",
    short: "Oct",
    value: 10,
    days: 31,
  },
  {
    label: "November",
    short: "Nov",
    value: 11,
    days: 30,
  },
  {
    label: "December",
    short: "Dec",
    value: 12,
    days: 31,
  },
];
